import { useMediaQuery } from 'react-responsive';

import supportMobile from '@/assets/images/support-mobile.webp';
import support from '@/assets/images/support.webp';

import styles from './Support.module.scss';

const Support = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  return (
    <section className={styles.support}>
      <h2 className={styles.title}>Поддержите бегунов и заявите о своих ценностях</h2>

      <div className={styles.supportBlock}>

        <div className={styles.leftBlock}>
          <div className={styles.card}>
            <div className={styles.subtitle}>
              Каждый шаг на дистанции наполняется стимулом и мотивацией, когда рядом кто-то верит в тебя! Это помогает преодолеть сложные участки дистанции, справиться с эмоциями и зарядиться энергией.
            </div>
            <ul className={styles.textBlock}>
              <li className={styles.text}><span className={styles.ellipse}></span>Станьте частью грандиозной поддержки на маршруте крупнейшего полумарафона России — <span className={styles.zabegText}>ЗаБег.РФ</span>, и устройте яркую атмосферу праздника!</li>
              <li className={styles.text}>Музыкальные и танцевальные коллективы, диджеи, рестораны, беговые клубы — точки поддержки могут быть очень разными!</li>
              <li className={styles.text}>Хотите организовать свою фан-точку на самом масштабном полумарафоне России и стать частью истории? Просто заполните заявку и мы начнём подготовку вместе!</li>
            </ul>
          </div>
          <div className={styles.wrapButton}>
            <a className={styles.link} target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/15jpRSmcyGebsanDzuLm1fUwjRbl5JZnWi1OA2Z32mrk/edit">
              ОСТАВИТЬ ЗАЯВКУ
            </a>
          </div>

        </div>
        <div className={styles.rightBlock}>
          <img className={styles.image} src={isMobile ? supportMobile : support} alt="" />
        </div>
      </div>



    </section>
  );
};

export default Support;